import styled from 'styled-components';

/* Chave de dois lados, logo abaixo do logo: separada do menu de propósito, para
   ler como seletor de modo e não como mais um item. Cores são as do próprio
   sidebar (borda e fundo do item ativo), nada novo entra. */
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const Toggle = styled.div`
  display: inline-flex;
  gap: 2px;
  padding: 3px;
  border-radius: 999px;
  border: 1px solid var(--neutral-stroke-stroke-dark, #ceced2);
  background: #ffffff;
`;

export const Cell = styled.button<{ $on: boolean }>`
  width: 30px;
  height: 26px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $on }) => ($on ? '#e7e8ec' : 'transparent')};
  cursor: ${({ $on }) => ($on ? 'default' : 'pointer')};
  transition: background 0.3s ease;

  &:hover {
    background: ${({ $on }) => ($on ? '#e7e8ec' : 'rgba(0, 0, 0, 0.04)')};
  }

  &:focus-visible {
    outline: 2px solid var(--neutral-stroke-stroke-dark, #ceced2);
    outline-offset: 1px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const Divider = styled.div`
  width: 56px;
  height: 1px;
  background: #e7e8ec;
`;
